export default __webpack_public_path__ + "images/LPA.53f4301.png";